import { calculateNights } from 'entities/kyrgyzstan/lib'
import type { DetailSearchParams } from 'entities/kyrgyzstan/model'
import { DefaultGuests } from 'entities/kyrgyzstan/model/search/search-store'

import type { RealtyPriceWithAvailabilityRequest } from 'shared/api/kyrgyzstan/search'
import { formatDateForApi } from 'shared/lib/formatDate'

interface GetBookingPriceParamsOptions {
  realtyId?: string
  detailSearchParams?: DetailSearchParams | null
  ratehawkBookHash?: string | null
}

export type BookingPriceParams = RealtyPriceWithAvailabilityRequest

export const getBookingPriceParams = ({
  realtyId,
  detailSearchParams,
  ratehawkBookHash,
}: GetBookingPriceParamsOptions): BookingPriceParams | null => {
  const startDate = detailSearchParams?.start_date
  const endDate = detailSearchParams?.end_date
  const visitorsCount =
    detailSearchParams?.visitors_count ?? DefaultGuests.adults
  const nights = calculateNights(startDate, endDate)

  if (!realtyId || !startDate || !endDate || !nights) {
    return null
  }

  return {
    realty_object_id: realtyId,
    start_date: formatDateForApi(startDate),
    nights,
    visitors_count: visitorsCount,
    ...(detailSearchParams?.children_ages?.length
      ? { children_ages: detailSearchParams.children_ages }
      : {}),
    ...(ratehawkBookHash ? { ratehawk_book_hash: ratehawkBookHash } : {}),
  }
}
